import { render } from "./VirtualMailboxGridItem.vue?vue&type=template&id=47325114"
import script from "./VirtualMailboxGridItem.vue?vue&type=script&lang=ts"
export * from "./VirtualMailboxGridItem.vue?vue&type=script&lang=ts"
script.render = render

export default script